import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
const { REQUEST_PREPARE_PROGREE_NOTE, SUCCESS_PREPARE_PROGREE_NOTE, FAILURE_PREPARE_PROGREE_NOTE } =
  documentationActions;

function* getPrepareProgressNote(action: any): SagaReturnType<any> {
  try {
    const response = yield call(
      templateService.getPrepareProgressNote,
      action.episodeOfCareId,
      action.params
    );
    if (response?.status === 200) {
      yield put({ type: SUCCESS_PREPARE_PROGREE_NOTE, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_PREPARE_PROGREE_NOTE, payload: error });
  }
}

function* getPrepareProgressNoteSaga() {
  yield takeEvery(REQUEST_PREPARE_PROGREE_NOTE, getPrepareProgressNote);
}

export default getPrepareProgressNoteSaga;
